// @flow

import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@components";

type OwnProps = $Exact<{
  ...PropsFromLocalize,
  onCancel: () => void,
  onSubmit: (form: Object) => void,
}>;

const SystemAccessConfirmMfaModal = (props: OwnProps) => {
  return (
    <Modal>
      <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
        {props.t("MULTI_FACTOR_AUTHENTICATION")}
      </ModalHeader>
      <ModalBody>{props.t("MULTI_FACTOR_AUTHENTICATION_CONFIRMATION_TEXT")}</ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onCancel}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="check" onClick={props.onSubmit}>
          {props.t("CONFIRM_MFA")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SystemAccessConfirmMfaModal;
